define('models/calendar/session/tag',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
], function(_, Backbone, U, API) {

    var MTag = Backbone.Epoxy.Model.extend({
        idAttribute: '_id',
        blacklist: ['group'],
        urlRoot: function() {
            var url = "exercises/tags/";

            if (this.isNew()) {
                return API.url("groups/" + this.get('group') + "/" + url);
            }

            return API.url(url);
        },

        defaults: function() {
            return {
                description: "",
                name: "",
                exercises: [],
            };
        },

        computeds: {
            label: function() {
                return this.get("name");
            },
            value: function() {
                return this.id;
            }
        },

        getSubtags: function() {
            return this.get('subtags');
        },

        getExercises: function() {
            return this.get('exercises');
        },

        hasExercises: function() {
            return !_.isEmpty(this.get('exercises'));
        },
    });

    // Return the model for the module
    return MTag;
});

